
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.363 8.504a.5.5 0 01.491.41l.009.09V21.38a.5.5 0 01-.41.492l-.09.008H2.044a.5.5 0 01-.492-.41l-.008-.09V9.004a.5.5 0 01.41-.492l.09-.008h4.319zm10.866-.01c3.157 0 5.178 2.36 5.268 6.276l.003.276v6.334a.5.5 0 01-.41.492l-.09.008h-4.771a.5.5 0 01-.492-.41l-.008-.09v-6.443a1.401 1.401 0 00-1.263-1.401l-.076-.005-.063.007c-.682 0-1.251.488-1.376 1.135l-.019.131-.006.135v6.441a.5.5 0 01-.41.492l-.09.008h-4.54a.5.5 0 01-.492-.41l-.008-.09V9.004a.5.5 0 01.41-.492l.09-.008h4.54a.5.5 0 01.492.41l.008.09v.439l.16-.095a6.507 6.507 0 012.503-.814l.332-.028.308-.011zM5.862 9.504H2.544V20.88h3.318V9.503zm11.37-.009l-.27.011a5.506 5.506 0 00-3.213 1.293.5.5 0 01-.817-.3l-.006-.082v-.913H9.385V20.88h3.541v-5.941c0-1.216.903-2.22 2.076-2.38l.161-.016.056-.002.019-.004.09-.008a2.401 2.401 0 012.394 2.22l.007.19-.001 5.941H21.5v-5.834c0-3.377-1.47-5.335-3.858-5.534l-.208-.013-.202-.005zM4.225 2A2.721 2.721 0 016.92 4.55l.001.029.014.052.008.09a2.721 2.721 0 11-2.887-2.716L4.225 2zm-.008 1l-.148.006A1.721 1.721 0 105.936 4.87l.002-.039-.005-.02-.008-.09c0-.895-.684-1.632-1.56-1.714L4.217 3z","fill":"#9A7C5D","fill-rule":"evenodd"}})])
          )
        }
      }
    